import { getReqAuth, postReqAuth } from '../../api';
import axios from 'axios';
import config from '../../../util/config';

export const getAllOmrPoints = (cb) => {
  getReqAuth('/webapi/institute/omrPoints', {}, '', cb);
};

export const getOmrPointDetail = (id, cb) => {
  getReqAuth('/webapi/institute/omrPoints/' + id, {}, '', cb);
};

export const updateOmrPoint = (id, data, cb) => {
  const token = localStorage.getItem('jwtToken');

  if (token) {
    axios.defaults.headers.common.Authorization = token;
    axios
      .put(config.BASE_API_URL + '/webapi/institute/omrPoints/' + id, data)
      .then((res) => {
        cb(null, res.data);
      })
      .catch((err) => {
        cb(err, null);
      });
  } else {
    cb('Not authenticated', null);
  }
};
